<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form @submit.prevent="askToSend(0)" novalidate>
                <div class="modal-header">
                    <button type="button" class="close" @click="goBack()" aria-hidden="true">×</button>
                    <h4 class="modal-title">{{ $t('email') }}</h4>
                </div>
                <div class="modal-body p-0">

                    <!-- Deal -->
                    <div class="modal_deal p_bottom_15">
                        <h5 class="m-t-0"><i class="fa-fw ti-user"></i> {{ $t('find_your_deal') }}</h5>
                        <pml-select-deals :hasEmail="1" v-model="search"  :exactDeal="exactDeal"></pml-select-deals>
                        <span class="error" v-if="errors['deal']">{{ errors['deal'][0] }}</span>
                    </div>

                    <!-- Email -->
                    <div class="modal_deal" v-pml-block="isLoading">
                        <div class="select_lead" v-if="!search">
                            <div class="d_table w_full h_full">
                                <div class="d_t_cell">
                                    <i class="fa fa-exclamation-triangle text-warning fa-3x"></i>
                                    <h4 class="t_uppercase"><b>{{ $t('select_a_deal') }}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-8 m_bottom_15" :class="{'has-error': errors['template_id']}">
                                <label>{{ $t('template') }}</label>
                                <pml-select v-model="record.template_id" :options="templates" label="title"></pml-select>
                                <span class="error" v-if="errors['template_id']">{{ errors['template_id'][0] }}</span>
                            </div>
                            <div class="col-sm-4 m_bottom_15 t_right m-t-25">
                                <span class="btn btn-white btn-sm btn_na" @click="toggleCC()" :class="{ 'active': showCC }" v-pml-tooltip="$t('carbon_copy')">{{ $t('cc') }}</span>
                                <span class="btn btn-white btn-sm btn_na" @click="toggleBCC()" :class="{ 'active': showBCC }" v-pml-tooltip="$t('blind_carbon_copy')">{{ $t('bcc') }}</span>
                            </div>
                            <div class="col-sm-12 m_bottom_15" :class="{'has-error': errors['subject']}">
                                <label>{{ $t('subject') }}</label>
                                <input type="text" class="form-control" v-model="record.subject">
                                <span class="error" v-if="errors['subject']">{{ errors['subject'][0] }}</span>
                            </div>
                            <div class="col-sm-12 m_bottom_15" v-if="showCC" :class="{'has-error': errors['cc']}">
                                <label>{{ $t('cc') }} <small class="text-muted">({{ $t('press_enter_or_tab_to_register') }})</small></label>
                                <pml-autocomplete-tag-input v-model="record.cc" :unfilteredTags="record.cc" :type="'email'" v-pml-autocomplete-tag-input-focus :options="emailAddresses"></pml-autocomplete-tag-input>
                                <span class="error" v-if="errors['cc']">{{ errors['cc'][0] }}</span>
                            </div>
                            <div class="col-sm-12 m_bottom_15" v-if="showBCC" :class="{'has-error': errors['bcc']}">
                                <label>{{ $t('bcc') }} <small class="text-muted">({{ $t('press_enter_or_tab_to_register') }})smonitor</small></label>
                                <pml-autocomplete-tag-input v-model="record.bcc" :unfilteredTags="record.bcc" :type="'email'" v-pml-autocomplete-tag-input-focus  :options="emailAddresses"></pml-autocomplete-tag-input>
                                <span class="error" v-if="errors['bcc']">{{ errors['bcc'][0] }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12" :class="{'has-error': errors['body']}">
                                <label>{{ $t('message') }}</label>
                                <pml-summernote v-model="record.body" :value="record.body" :show-deal-btn="false"></pml-summernote>
                                <span class="error" v-if="errors['body']">{{ errors['body'][0] }}</span>
                            </div>
                        </div>
                        <div class="d_flex flex_wrap h_34 m-t-15 f_justify_end w_full_450">
                            <div class="m-r-10" v-if="record.is_scheduled" :class="{'has-error': errors['scheduled_at']}">
                                <pml-datetime-picker v-model="record.scheduled_at" v-pml-focus class="w_140"></pml-datetime-picker>
                                <span class="show error text-center" v-if="errors['scheduled_at']">{{ errors['scheduled_at'][0] }}</span>
                            </div>
                            <pml-switch v-model="record.is_scheduled" :text="$t('set_scheduling')" class="switch_text_left m-r-15"></pml-switch>
                        </div>
                    </div>
                </div>
                <div class="p-15 t_right">
                    <span class="btn btn-white pull-left btn_mobile_block" @click="goBack()">{{ $t('cancel') }}</span>
                    <a href="#" @click.prevent="askToSend(1)" class="btn btn_green btn_mobile_block" :disabled="!search" v-pml-block="isSaving">{{ $t('save_and_go_to_deal') }}</a>
                    <button type="submit" class="btn btn-default btn_mobile_block" :disabled="!search" v-pml-block="isSaving">{{ $t('save') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import RoutedModals from 'utils/mixins/routed-modals'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { mapGetters } from 'vuex'
    import { create, replace, signature } from 'services/emails'
    import { sendEmail } from 'utils/helpers/sweet-alert'
    import bus from 'utils/events/bus'
    import { isNull } from 'lodash'
    import { getEmailAddresses } from 'utils/helpers/emails'

    export default {
        name: 'EmailCreate',
        mixins: [ RoutedModals ],
        data () {
            return {
                exactDeal: null,
                search: null,
                isSaving: false,
                isLoading: false,
                showCC: false,
                showBCC: false,
                record: {
                    cc: null,
                    bcc: null,
                    body: null,
                    template_id: null,
                    scheduled_at: '',
                    schedule: false
                },
                errors: [],
                emailAddresses: []
            }
        },
        metaInfo () {
            return {
                title: trans('create_a_new_email')
            }
        },
        created () {
            let verifyId = window.sessionStorage.getItem('pipeline_card_action_deal_id')
            if (typeof verifyId !== 'undefined' && !isNull(verifyId) && !isNaN(verifyId))
                this.exactDeal = parseInt(verifyId)
        },
        beforeDestroy () {
            window.sessionStorage.removeItem('pipeline_card_action_deal_id')
        },
        computed: {
            ...mapGetters({
                'member': 'getMember',
                'templates': 'getTemplates'
            })
        },
        watch: {
            'record.template_id' (val, old) {
                if (val !== '' && val !== old && !isNull(this.record.template_id) && !isNull(this.search)) {
                    this.isLoading = true

                    replace(this.record.template_id, this.search.id)
                        .then(response => {
                            this.record.subject = response.data.subject
                            this.record.body = response.data.body
                        })
                        .catch(() => Notify.error(trans('_notifications.error')))
                        .then(() => { this.isLoading = false })
                } else if (!isNull(this.search)) {
                    this.initEmailSignature()
                }
            },
            'search' (val) {
                if (!isNull(val)) {
                    this.initEmailSignature()
                    this.getEmailAddresses()
                }
            }
        },
        methods: {
            initEmailSignature () {
                this.record.subject = ''
                this.record.body = ''
                if (this.member.active_email_signature && !isNull(this.search))
                    signature(this.search.id)
                        .then(response => {
                            this.record.body = response.data.body
                        })
            },
            askToSend (redirect) {
                sendEmail()
                    .then((response) => (response.value) ? this.store(redirect) : null)
            },
            store (redirect) {
                if (this.search === null) {
                    this.errors = { 'deal': [trans('this_field_is_required')] }
                    return
                }

                this.isSaving = true

                create(this.search.id, this.record)
                    .then(response => {
                        if (redirect) {
                            this.$router.push({ name: 'deals.show.emails', params: { id: response.deal_id } })
                        } else {
                            bus.$emit('refreshEmailsCard')
                            bus.$emit('refreshDealsCard')
                        }
                        Notify.success(trans('_notifications.success'))
                        this.clear()
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            },
            toggleCC () {
                this.showCC = !this.showCC
                this.record.cc = null
            },
            toggleBCC () {
                this.showBCC = !this.showBCC
                this.record.bcc = null
            },
            clear () {
                this.search = null
                this.isSaving = false
                this.showCC = false
                this.showBCC = false
                this.record = {
                    cc: null,
                    bcc: null,
                    body: null,
                    template_id: null,
                    is_scheduled: false
                }
                this.errors = []
                if (!isNull(this.exactDeal))
                    window.sessionStorage.removeItem('pipeline_card_action_deal_id')
            },
            getEmailAddresses () {
                this.emailAddresses = getEmailAddresses(this.search.emails, this.search.lead, this.member)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/emails/components/Create.vue